
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function MainContentRT () {
    return _createElement('div', { 'id': 'itemsBlock' }, [this.FilterSearchBox(function () {
            return _createElement('div', { 'className': 'cm_FilterSearchBox' }, _createElement('form', {
                'className': 'cm_filter-search-box live-search-form form-fields-inline form-field no-label',
                'onSubmit': this.onSubmit
            }, _createElement('input', {
                'className': 'cm_filter-search-box__input form-field-input live-search-form-field',
                'type': 'text',
                'placeholder': 'Search within Samples',
                'value': this.value,
                'onChange': this.onChange
            }), _createElement('span', { 'className': 'cm_filter-search-box__clear-container' }, this.inputNotEmpty ? _createElement('span', {
                'className': 'cm_filter-search-box__clear',
                'onClick': this.clearInput,
                'key': '393'
            }, '\n      ', window.innerWidth > 768 ? '\u2715' : 'Clear', '\n    ') : null), _createElement('input', {
                'className': 'cm_filter-search-box__submit live-search-button',
                'type': 'submit',
                'value': ''
            })));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.message(function () {
            return _createElement('div', { 'className': 'cm_message' }, this.hasMessage('DemoPlanActive') ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.hasMessage('TrialExpired') ? [_createElement('div', { 'key': '3250' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                    'href': 'mailto:support@convermax.com',
                    'className': 'cm_message-link'
                }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.hasMessage('AggressiveWheels') ? [_createElement('div', { 'key': '7990' }, '\n  Warning: Aggressive wheel options are displayed, but we cannot guarantee they will fit your selected\n  vehicle.\n')] : null, this.hasMessage('IncompatibleParts') && !this.notFilteredByVehicle ? [_createElement('div', {
                    'className': 'cm_message__incompatible',
                    'key': '10060'
                }, _createElement('div', {}, '\n    The products shown below will not fit a ', _createElement('span', {}, this.vehicleString), '.', _createElement('br', {}), '\n    The products results are based on your keyword search only.\n  '))] : null, this.isNoVehicleSpecificResults && this.isVehicleSelected && !this.notFilteredByVehicle && !this.hasMessage('NonVehicleProducts') ? [_createElement('div', {
                    'className': 'cm_message__universal',
                    'key': '13360'
                }, '\n  The system was unable to find any vehicle specific products that fit a\n  ', _createElement('span', {}, '\'', this.vehicleString, '\'.'), _createElement('br', {}), '\n  Click ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'href': this.searchByVehicleUrl
                }, 'here'), ' to clear your vehicle\n  selection and browse all products in the category.\n')] : null, this.template === 'badRequest' ? _createElement('div', {
                'className': 'cmTemplate_badRequest',
                'key': '1869'
            }, 'Your request failed to process (', _createElement('b', {}, 'status:'), ' ', this.error.status, ', ', _createElement('b', {}, 'id:'), ' ', this.error.userId, ',\n', _createElement('b', {}, 'timestamp:'), ' ', this.error.timestamp, ', ', _createElement('b', {}, 'instance:'), ' ', this.error.instance, ').\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.startOver
            }, 'clear your search'), ' and try\nsearching for something else.\n') : null, this.template === 'corrected' ? _createElement('div', {
                'className': 'cmTemplate_corrected',
                'key': '2283'
            }, 'Your search for ', _createElement('span', { 'className': 'query' }, this.originalQuery), '\ndid not match any products. The system searched for\n', _createElement('span', { 'className': 'query' }, this.query), ' instead.\n') : null, this.template === 'networkError' ? _createElement('div', {
                'className': 'cmTemplate_networkError',
                'key': '2537'
            }, 'Network error\n', this.error ? [
                '(id: ',
                this.error.userId,
                ', timestamp: ',
                this.error.timestamp,
                ', instance: ',
                this.error.instance,
                ')'
            ] : null, '.\n', _createElement('br', {}), '\nThe search server could not be reached. Please try again later.\n') : null, this.template === 'nothing' ? _createElement('div', {
                'className': 'cmTemplate_nothing',
                'key': '2855'
            }, _createElement('div', {}, this.pageType !== 'search' && (!this.isFacetsSelected || this.notFilteredByVehicle || this.isUniversal) ? [
                '\n    This ',
                this.pageType,
                ' doesn\'t contain any\n    ',
                !!this.vehicleString && !this.notFilteredByVehicle ? [
                    '\n      products that fit a ',
                    _createElement('span', { 'key': '31381' }, '\'', this.vehicleString, '\'.')
                ] : null,
                !this.vehicleString || this.notFilteredByVehicle ? [' products.'] : null
            ] : null, this.pageType === 'search' ? [_createElement('div', { 'key': '34201' }, 'No results were found for your search.')] : null, this.query || !!this.vehicleString && !this.notFilteredByVehicle && !this.isUniversal ? [
                '\n    Click ',
                _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'onClick': this.startOver,
                    'key': '35511'
                }, 'here'),
                ' to clear\n    ',
                !this.vehicleString ? [' selection. '] : null,
                this.vehicleString && (!this.isFacetsSelected || !this.notFilteredByVehicle) ? ['\n      all keyword searches, filter selections, and vehicle selections to again browse all products.\n    '] : null
            ] : null)) : null, this.template === 'timeout' ? _createElement('div', {
                'className': 'cmTemplate_timeout',
                'key': '4099'
            }, 'Your search request timed out.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, 'try your search again'), '.\n') : null, this.template === 'partial' ? _createElement('div', {
                'className': 'cmTemplate_partial',
                'key': '4318'
            }, 'The system was unable to find products to match your entire search of\n', _createElement('span', { 'className': 'query' }, this.originalQuery), '. A partial search was performed instead.\n') : null, this.template === 'unknown' ? _createElement('div', {
                'className': 'cmTemplate_unknown',
                'key': '4562'
            }, 'Your search request failed to process\n', this.error ? [
                '\n  (',
                this.error.status ? [
                    _createElement('b', { 'key': '47130' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '48000' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '48830' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '46784' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null, '.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, 'try your search again'), '.\n') : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.customMessage(function () {
            return _createElement('div', { 'className': 'cm_message cm_customMessage' }, []);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchHeader(function () {
            return _createElement('div', { 'className': 'cm_SearchHeader' }, [this.facetDialogButton(function () {
                    return _createElement('div', { 'className': 'cm_facetDialogButton' }, [this.dialogButton(function () {
                            return _createElement('div', { 'className': 'cm_dialogButton' }, _createElement('button', {
                                'className': 'utils-filter-button',
                                'type': 'button',
                                'aria-label': 'Filters',
                                'data-productgrid-trigger-filters': true
                            }, _createElement('span', { 'className': 'utils-filter-icon' }, _createElement('svg', {
                                'className': 'icon-filters',
                                'aria-hidden': 'true',
                                'focusable': 'false',
                                'role': 'presentation',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'width': '20',
                                'height': '20',
                                'viewBox': '0 0 20 20',
                                'fill': 'currentColor'
                            }, _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M16.8733 3.448H19.0202C19.5613 3.448 20 3.88666 20 4.42777C20 4.96888 19.5613 5.40753 19.0202 5.40753H16.8733C16.6687 6.11494 16.2488 6.73525 15.6759 7.17629C15.1031 7.61732 14.4078 7.85553 13.6935 7.85553C12.9792 7.85553 12.284 7.61732 11.7111 7.17629C11.1382 6.73525 10.7183 6.11494 10.5137 5.40753H0.979765C0.438656 5.40753 0 4.96888 0 4.42777C0 3.88666 0.438656 3.448 0.979764 3.448H10.5137C10.7183 2.74059 11.1382 2.12028 11.7111 1.67925C12.284 1.23822 12.9792 1 13.6935 1C14.4078 1 15.1031 1.23822 15.6759 1.67925C16.2488 2.12028 16.6687 2.74059 16.8733 3.448ZM9.49889 14H19.0177C19.5588 14 19.9975 14.4387 19.9975 14.9798C19.9975 15.5209 19.5588 15.9595 19.0177 15.9595H9.49889C9.29432 16.6669 8.8744 17.2873 8.30153 17.7283C7.72866 18.1693 7.03342 18.4075 6.31912 18.4075C5.60481 18.4075 4.90957 18.1693 4.3367 17.7283C3.76383 17.2873 3.34391 16.6669 3.13934 15.9595H0.979764C0.438655 15.9595 0 15.5209 0 14.9798C0 14.4387 0.438655 14 0.979763 14H3.13934C3.34391 13.2926 3.76383 12.6723 4.3367 12.2312C4.90957 11.7902 5.60481 11.552 6.31912 11.552C7.03342 11.552 7.72866 11.7902 8.30153 12.2312C8.8744 12.6723 9.29432 13.2926 9.49889 14ZM6.31912 16.776C5.85823 16.776 5.41623 16.5868 5.09034 16.2499C4.76444 15.913 4.58136 15.4562 4.58136 14.9798C4.58136 14.5034 4.76444 14.0465 5.09034 13.7096C5.41623 13.3728 5.85823 13.1835 6.31912 13.1835C6.78 13.1835 7.222 13.3728 7.5479 13.7096C7.87379 14.0465 8.05687 14.5034 8.05687 14.9798C8.05687 15.4562 7.87379 15.913 7.5479 16.2499C7.222 16.5868 6.78 16.776 6.31912 16.776ZM13.6935 6.224C13.2326 6.224 12.7906 6.03476 12.4647 5.6979C12.1389 5.36104 11.9558 4.90416 11.9558 4.42777C11.9558 3.95138 12.1389 3.4945 12.4647 3.15764C12.7906 2.82078 13.2326 2.63153 13.6935 2.63153C14.1544 2.63153 14.5964 2.82078 14.9223 3.15764C15.2482 3.4945 15.4313 3.95138 15.4313 4.42777C15.4313 4.90416 15.2482 5.36104 14.9223 5.6979C14.5964 6.03476 14.1544 6.224 13.6935 6.224Z',
                                'fill': 'currentColor'
                            }))), _createElement('span', { 'className': 'utils-filter-text' }, 'Filters')));
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('div', { 'className': 'cm_sort sort-by' }, _createElement('span', { 'className': 'sort-label' }, 'Sort by'), '\n  ', this.sortSelect, '\n'), _createElement('div', { 'className': 'cm_total-hits' }, _createElement('span', {}, this.totalHits, ' results')));
        }, {
            widgetName: 'search-header',
            items: undefined
        })], [this.SearchResult(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        function mergeProps(inline, external) {
                            var res = Object.assign({}, inline, external);
                            if (inline.hasOwnProperty('style')) {
                                res.style = _.defaults(res.style, inline.style);
                            }
                            if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                res.className = external.className + ' ' + inline.className;
                            }
                            return res;
                        }
                        function repeatRelated_product2(related_product, related_productIndex) {
                            return _createElement('div', {
                                'className': 'item' + (related_product.title === 'More Colors' ? ' item-more-colors' : ''),
                                'key': 'rel-' + this.id + '-' + related_productIndex
                            }, related_product.title === 'More Colors' ? _createElement('a', {
                                'href': related_product.url,
                                'title': related_product.title,
                                'key': '3582'
                            }, _createElement('svg', {
                                'width': '25',
                                'height': '24',
                                'viewBox': '0 0 25 24',
                                'fill': 'currentColor',
                                'xmlns': 'http://www.w3.org/2000/svg'
                            }, _createElement('path', {
                                'd': 'M 12.5 3 L 12.5 22 M 3 12.5 L 22 12.5',
                                'stroke': 'currentColor',
                                'stroke-width': '3',
                                'stroke-linecap': 'round',
                                'fill': 'none'
                            }))) : null, related_product.title !== 'More Colors' && related_product.image ? _createElement('a', {
                                'className': 'shop-thumbnail',
                                'href': related_product.url,
                                'title': related_product.title,
                                'data-ladc-colorway': true,
                                'data-ladc-product': this.id,
                                'data-src': related_product.image,
                                'key': '4003'
                            }, _createElement('img', {
                                'className': 'color-thumbnail',
                                'src': this.setImageSize(related_product.image, 46, 46, 'center'),
                                'alt': related_product.title,
                                'width': '46',
                                'height': '46',
                                'loading': 'lazy'
                            }), _createElement('br', {})) : null);
                        }
                        return _createElement('li', {
                            'className': 'productgrid--item imagestyle--cropped-medium productitem--emphasis show-actions--mobile',
                            'data-product-item': true,
                            'data-product-quickshop-url': this.url || this.promotion_url,
                            'data-quickshop-hash': true
                        }, !this.is_promotional_item ? _createElement('div', {
                            'className': 'productitem',
                            'data-product-item-content': true,
                            'key': '211'
                        }, _createElement('a', {
                            'className': 'productitem--image-link',
                            'href': this.url,
                            'tabIndex': '-1',
                            'data-product-page-link': true
                        }, this.pattern_logo ? _createElement('img', {
                            'className': 'manufacturer-logo',
                            'src': this.pattern_logo,
                            'alt': this.vendor,
                            'width': '250',
                            'height': '50',
                            'loading': 'lazy',
                            'key': '404'
                        }) : null, _createElement('figure', {
                            'className': 'productitem--image',
                            'data-product-item-image': true,
                            'data-ladc-colorway-target': this.id,
                            'data-ladc-initial-image': this.imageOrDefault(this.resizeImage(this.image))
                        }, _createElement('img', {
                            'src': this.imageOrDefault(this.resizeImage(this.image)),
                            'alt': this.removeHTML(this.title),
                            'className': 'productitem--image-primary',
                            'onError': this.onImageError
                        }))), _createElement('h2', { 'className': 'productitem--title' }, _createElement('a', {
                            'href': this.url,
                            'data-product-page-link': true
                        }, _createElement('span', mergeProps({ 'className': 'product-brand' }, { dangerouslySetInnerHTML: { __html: this.vendor } })), _createElement('span', mergeProps({ 'className': 'product-pattern' }, { dangerouslySetInnerHTML: { __html: this.pattern_name || this.pattern_number } })), _createElement('span', mergeProps({ 'className': 'product-color' }, { dangerouslySetInnerHTML: { __html: this.pattern_color } })), _createElement('span', mergeProps({ 'className': 'product-category' + (this.product_type == 'Sample' ? ' product-category_sample' : '') }, { dangerouslySetInnerHTML: { __html: this.product_type } })))), _createElement('div', { 'className': 'productitem--info' }, _createElement('div', { 'className': 'price productitem__price' }, this.price ? [
                            _createElement('div', {
                                'className': 'price__current price__current--emphasize',
                                'data-price-container': true,
                                'key': '16721'
                            }, this.product_type !== 'Sample' && !this.hide_retail_price && this.retail_price_multiplier && this.retail_price_multiplier !== 0 ? _createElement('div', {
                                'className': 'retail-price',
                                'key': '1805'
                            }, '\n              Retail ', this.formatPrice(this.price * this.retail_price_multiplier), '\n            ') : null, _createElement('span', {
                                'className': 'money',
                                'data-price': true
                            }, this.formatPrice(this.price)), this.quantity_unit ? _createElement('span', {
                                'className': 'after-money',
                                'key': '2200'
                            }, this.product_type !== 'Sample' ? [
                                ' Per ',
                                this.quantity_unit
                            ] : null) : null, _createElement('br', {})),
                            _createElement('div', {
                                'className': 'productitem__unit-price hidden',
                                'data-unit-price': true,
                                'key': '16723'
                            }, _createElement('span', {
                                'className': 'productitem__total-quantity',
                                'data-total-quantity': true
                            }), ' |\n            ', _createElement('span', {
                                'className': 'productitem__unit-price--amount money',
                                'data-unit-price-amount': true
                            }), ' /\n            ', _createElement('span', {
                                'className': 'productitem__unit-price--measure',
                                'data-unit-price-measure': true
                            }))
                        ] : null, !this.price ? [_createElement('div', {
                                'className': 'price__current price__current--emphasize',
                                'data-price-container': true,
                                'key': '28071'
                            }, this.pattern_quote_price ? [_createElement('a', {
                                    'className': 'price__quote-link',
                                    'href': this.url,
                                    'key': '29411'
                                }, 'INSTANT QUOTE')] : null, !this.pattern_quote_price ? [_createElement('a', {
                                    'className': 'price__quote-link',
                                    'href': this.url,
                                    'key': '31041'
                                }, 'REQUEST QUOTE')] : null)] : null), _createElement.apply(this, [
                            'div',
                            { 'className': 'productitem--colorways' },
                            _map(this.related_products, repeatRelated_product2.bind(this))
                        ]), _createElement('div', { 'className': 'productitem--description' }))) : null, this.is_promotional_item ? _createElement('div', {
                            'className': 'productitem promotional_item',
                            'data-product-item-content': true,
                            'key': '4586'
                        }, _createElement('a', {
                            'className': 'productitem--image-link',
                            'href': this.promotion_url,
                            'tabIndex': '-1',
                            'data-product-page-link': true
                        }, _createElement('figure', {
                            'className': 'productitem--image',
                            'data-product-item-image': true,
                            'data-ladc-initial-image': this.imageOrDefault(this.setImageSize(this.promotion_image_url, 500))
                        }, _createElement('img', {
                            'src': this.imageOrDefault(this.setImageSize(this.promotion_image_url, 500)),
                            'alt': this.removeHTML(this.promotion_button_text),
                            'className': 'productitem--image-primary',
                            'onError': this.onImageError
                        }))), _createElement('div', { 'className': 'productitem--info' }, _createElement('div', { 'className': 'price productitem__price' }, _createElement('div', {
                            'className': 'price__current price__current--emphasize',
                            'data-price-container': true
                        }, _createElement('a', {
                            'className': 'price__quote-link',
                            'href': this.promotion_url
                        }, this.promotion_button_text))))) : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_SearchResult' }, _createElement.apply(this, [
                'ul',
                { 'className': 'productgrid--items products-per-row-4' + (this.view ? ` ${ this.view }` : '') + ' cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.message(function () {
                    return _createElement('div', { 'className': 'cm_message' }, this.hasMessage('DemoPlanActive') ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.hasMessage('TrialExpired') ? [_createElement('div', { 'key': '3250' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                            'href': 'mailto:support@convermax.com',
                            'className': 'cm_message-link'
                        }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.hasMessage('AggressiveWheels') ? [_createElement('div', { 'key': '7990' }, '\n  Warning: Aggressive wheel options are displayed, but we cannot guarantee they will fit your selected\n  vehicle.\n')] : null, this.hasMessage('IncompatibleParts') && !this.notFilteredByVehicle ? [_createElement('div', {
                            'className': 'cm_message__incompatible',
                            'key': '10060'
                        }, _createElement('div', {}, '\n    The products shown below will not fit a ', _createElement('span', {}, this.vehicleString), '.', _createElement('br', {}), '\n    The products results are based on your keyword search only.\n  '))] : null, this.isNoVehicleSpecificResults && this.isVehicleSelected && !this.notFilteredByVehicle && !this.hasMessage('NonVehicleProducts') ? [_createElement('div', {
                            'className': 'cm_message__universal',
                            'key': '13360'
                        }, '\n  The system was unable to find any vehicle specific products that fit a\n  ', _createElement('span', {}, '\'', this.vehicleString, '\'.'), _createElement('br', {}), '\n  Click ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'href': this.searchByVehicleUrl
                        }, 'here'), ' to clear your vehicle\n  selection and browse all products in the category.\n')] : null, this.template === 'badRequest' ? _createElement('div', {
                        'className': 'cmTemplate_badRequest',
                        'key': '1869'
                    }, 'Your request failed to process (', _createElement('b', {}, 'status:'), ' ', this.error.status, ', ', _createElement('b', {}, 'id:'), ' ', this.error.userId, ',\n', _createElement('b', {}, 'timestamp:'), ' ', this.error.timestamp, ', ', _createElement('b', {}, 'instance:'), ' ', this.error.instance, ').\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.startOver
                    }, 'clear your search'), ' and try\nsearching for something else.\n') : null, this.template === 'corrected' ? _createElement('div', {
                        'className': 'cmTemplate_corrected',
                        'key': '2283'
                    }, 'Your search for ', _createElement('span', { 'className': 'query' }, this.originalQuery), '\ndid not match any products. The system searched for\n', _createElement('span', { 'className': 'query' }, this.query), ' instead.\n') : null, this.template === 'networkError' ? _createElement('div', {
                        'className': 'cmTemplate_networkError',
                        'key': '2537'
                    }, 'Network error\n', this.error ? [
                        '(id: ',
                        this.error.userId,
                        ', timestamp: ',
                        this.error.timestamp,
                        ', instance: ',
                        this.error.instance,
                        ')'
                    ] : null, '.\n', _createElement('br', {}), '\nThe search server could not be reached. Please try again later.\n') : null, this.template === 'nothing' ? _createElement('div', {
                        'className': 'cmTemplate_nothing',
                        'key': '2855'
                    }, _createElement('div', {}, this.pageType !== 'search' && (!this.isFacetsSelected || this.notFilteredByVehicle || this.isUniversal) ? [
                        '\n    This ',
                        this.pageType,
                        ' doesn\'t contain any\n    ',
                        !!this.vehicleString && !this.notFilteredByVehicle ? [
                            '\n      products that fit a ',
                            _createElement('span', { 'key': '31381' }, '\'', this.vehicleString, '\'.')
                        ] : null,
                        !this.vehicleString || this.notFilteredByVehicle ? [' products.'] : null
                    ] : null, this.pageType === 'search' ? [_createElement('div', { 'key': '34201' }, 'No results were found for your search.')] : null, this.query || !!this.vehicleString && !this.notFilteredByVehicle && !this.isUniversal ? [
                        '\n    Click ',
                        _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'onClick': this.startOver,
                            'key': '35511'
                        }, 'here'),
                        ' to clear\n    ',
                        !this.vehicleString ? [' selection. '] : null,
                        this.vehicleString && (!this.isFacetsSelected || !this.notFilteredByVehicle) ? ['\n      all keyword searches, filter selections, and vehicle selections to again browse all products.\n    '] : null
                    ] : null)) : null, this.template === 'timeout' ? _createElement('div', {
                        'className': 'cmTemplate_timeout',
                        'key': '4099'
                    }, 'Your search request timed out.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, 'try your search again'), '.\n') : null, this.template === 'partial' ? _createElement('div', {
                        'className': 'cmTemplate_partial',
                        'key': '4318'
                    }, 'The system was unable to find products to match your entire search of\n', _createElement('span', { 'className': 'query' }, this.originalQuery), '. A partial search was performed instead.\n') : null, this.template === 'unknown' ? _createElement('div', {
                        'className': 'cmTemplate_unknown',
                        'key': '4562'
                    }, 'Your search request failed to process\n', this.error ? [
                        '\n  (',
                        this.error.status ? [
                            _createElement('b', { 'key': '47130' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '48000' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '48830' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '46784' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null, '.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, 'try your search again'), '.\n') : null);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'results',
            items: undefined
        })], [this.paginationMenu(function () {
            function repeatButtons1(buttons, buttonsIndex) {
                return [buttons(function () {
                        return this.template === 'prev' ? _createElement('a', {
                            'href': `?pageNumber=${ this.page }`,
                            'className': 'cm_pagination-content_button cmTemplate_prev'
                        }, _createElement('i', { 'className': 'bordered fa fa-solid fa-angle-left' })) : this.template === 'prevStub' ? _createElement('a', {
                            'className': 'cm_pagination-content_button cmTemplate_prevStub',
                            'disabled': true
                        }, _createElement('i', { 'className': 'bordered fa fa-solid fa-angle-left' })) : this.template === 'next' ? _createElement('a', {
                            'href': `?pageNumber=${ this.page }`,
                            'className': 'cm_pagination-content_button cmTemplate_next'
                        }, _createElement('i', { 'className': 'bordered fa fa-solid fa-angle-right' })) : this.template === 'nextStub' ? _createElement('a', {
                            'className': 'cm_pagination-content_button cmTemplate_nextStub',
                            'disabled': true
                        }, _createElement('i', { 'className': 'bordered fa fa-solid fa-angle-right' })) : this.template === 'delimiter' ? _createElement('span', { 'className': 'cm_pagination-content_button cm_pagination-delimiter cmTemplate_delimiter' }, '\n    ...\n  ') : this.template === 'page' ? _createElement('span', { 'className': 'cm_pagination-content_button ' + (this.isActive ? 'cm_pagination-content_button-current' : '') + ' cmTemplate_page' }, this.isActive ? _createElement('span', {
                            'className': 'cm_toggle-dropdown',
                            'key': '146'
                        }, '\n      Page ', this.page, ' ', _createElement('i', { 'className': 'fa fa-solid fa-angle-down' })) : null, !this.isActive ? _createElement('a', {
                            'href': '?pageNumber=' + this.page,
                            'className': 'cm_pagination-button',
                            'key': '280'
                        }, this.page) : null) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_paginationMenu' }, this.hasNextPage ? _createElement('div', {
                'className': 'cm_load-more-button-container',
                'key': '31'
            }, _createElement('div', {
                'className': 'cm_load-more-button ladc-button primary',
                'onClick': this.loadNextPage
            }, 'Load More')) : null, _createElement.apply(this, [
                'span',
                { 'className': 'cm_pagination-content cmRepeater_buttons' },
                _map(this.buttons, repeatButtons1.bind(this))
            ]), [this.paginationDropdown(function () {
                    function repeatPages1(pages, pagesIndex) {
                        return [pages(function () {
                                return this.template === 'page' ? _createElement('li', { 'className': 'cm_scroll-item cm_pagination-page ' + (this.isActive ? 'current' : '') + ' cmTemplate_page' }, _createElement('a', { 'href': '?pageNumber=' + this.page }, 'Page ', this.page)) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_paginationDropdown' }, _createElement('div', {
                        'className': 'cm_scroll-viewport cm_pagination-pages-container',
                        'onScroll': this.onViewportScroll
                    }, _createElement.apply(this, [
                        'ul',
                        { 'className': 'cm_scroll-container cm_pagination-pages cmRepeater_pages' },
                        _map(this.pages, repeatPages1.bind(this))
                    ])));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:FilterSearchBox","cm:message","cm:customMessage","cm:dialogButton","cm:facetDialogButton","cm:SearchHeader","cm:message","cm:SearchResult","cm:paginationDropdown","cm:paginationMenu"]